import { Trans, useTranslation } from "react-i18next";

import Dialog from "@/components/Dialog/Dialog";
import { DialogWidth } from "@/components/Dialog/types/enums";
import TextLink from "@/components/TextLink/TextLink";
import { TEXT_LINK_SIZES } from "@/components/TextLink/types";
import { useMediaQueries } from "@/shared";
import DialogActions from "@/shared/components/buttons/DialogActions";

interface InaccessibleImeiDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

const InaccessibleImeiDialog = ({
  isOpen,
  onClose
}: InaccessibleImeiDialogProps) => {
  const { t } = useTranslation();
  const { toMd } = useMediaQueries();

  return (
    <Dialog
      title={t("Dialog##vehicle imei in use inaccessible##title")}
      description={
        <Trans
          i18nKey="Dialog##vehicle imei in use inaccessible##description"
          components={{
            supportLink: (
              <TextLink
                size={TEXT_LINK_SIZES.Normal}
                href="https://www.teltonika-gps.com/support/product-support"
                target="_blank"
              />
            )
          }}
        />
      }
      extendToMaxWidth={toMd}
      isActionsSeparator
      open={isOpen}
      close={onClose}
      width={toMd ? undefined : DialogWidth.MinWidth}
      actions={
        <DialogActions
          onClose={onClose}
          isLoading={false}
          hideAcceptButton
          isreadyToConfirm
          cancelButtonText={t("Button##back")}
          cancelButtonTestId="close-inaccessible-imei-dialog"
        />
      }
    />
  );
};

export default InaccessibleImeiDialog;
